<template lang='pug'>
//- Youtube播放框
div(:class='$style[`cc-popbox-youtube`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-player`]' ref='youtubePlayer')
      //- iframe(
      //-   width='100%'
      //-   height='100%'
      //-   frameborder='0'
      //-   allowfullscreen
      //-   :src='link')
      youtube(
        :video-id="link"
        :ref="`youtube`"
        :resize='true'
        :fitParent='true'
        @playing="handleYoutubePlaying")

</template>

<script>
import { mapMutations } from 'vuex';

export default {

  props: {
    link: {
      type: String,
      default: '',
    },
  },

  // data() {
  //   return {
  //   }
  // },

  methods: {
    ...mapMutations({
      changePopYoutubeStatus: 'global/POPYOUTUBE_STATUS',
    }),

    handleYoutubePlaying() {
      console.log('start playing');
    },

    handleClosePopBox() {
      this.changePopYoutubeStatus({
        active: false,
        link: '',
      });
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popYoutube.scss';
</style>
